var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { SurveyQuestionMatrixDropdownBase } from "./reactquestion_matrixdropdownbase";
import { ReactElementFactory } from "./element-factory";
import { ReactSurveyElement } from "./reactquestion_element";
var SurveyQuestionMatrixDynamic = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixDynamic, _super);
    function SurveyQuestionMatrixDynamic(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnRowAddClick = _this.handleOnRowAddClick.bind(_this);
        return _this;
    }
    Object.defineProperty(SurveyQuestionMatrixDynamic.prototype, "matrix", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixDynamic.prototype.handleOnRowAddClick = function (event) {
        this.matrix.addRowUI();
    };
    SurveyQuestionMatrixDynamic.prototype.renderElement = function () {
        var cssClasses = this.question.cssClasses;
        var showTable = this.question.renderedTable.showTable;
        var mainDiv = showTable
            ? this.renderTableDiv()
            : this.renderNoRowsContent(cssClasses);
        return (React.createElement("div", null,
            this.renderAddRowButtonOnTop(cssClasses),
            mainDiv,
            this.renderAddRowButtonOnBottom(cssClasses)));
    };
    SurveyQuestionMatrixDynamic.prototype.renderAddRowButtonOnTop = function (cssClasses) {
        if (!this.matrix.renderedTable.showAddRowOnTop)
            return null;
        return this.renderAddRowButton(cssClasses);
    };
    SurveyQuestionMatrixDynamic.prototype.renderAddRowButtonOnBottom = function (cssClasses) {
        if (!this.matrix.renderedTable.showAddRowOnBottom)
            return null;
        return this.renderAddRowButton(cssClasses);
    };
    SurveyQuestionMatrixDynamic.prototype.renderNoRowsContent = function (cssClasses) {
        return ReactElementFactory.Instance.createElement("sv-placeholder-matrixdynamic", { cssClasses: cssClasses, question: this.matrix });
    };
    SurveyQuestionMatrixDynamic.prototype.renderAddRowButton = function (cssClasses, isEmptySection) {
        if (isEmptySection === void 0) { isEmptySection = false; }
        return ReactElementFactory.Instance.createElement("sv-matrixdynamic-add-btn", {
            question: this.question,
            cssClasses: cssClasses,
            isEmptySection: isEmptySection
        });
    };
    return SurveyQuestionMatrixDynamic;
}(SurveyQuestionMatrixDropdownBase));
export { SurveyQuestionMatrixDynamic };
ReactQuestionFactory.Instance.registerQuestion("matrixdynamic", function (props) {
    return React.createElement(SurveyQuestionMatrixDynamic, props);
});
var SurveyQuestionMatrixDynamicAddButton = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixDynamicAddButton, _super);
    function SurveyQuestionMatrixDynamicAddButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnRowAddClick = _this.handleOnRowAddClick.bind(_this);
        return _this;
    }
    Object.defineProperty(SurveyQuestionMatrixDynamicAddButton.prototype, "matrix", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixDynamicAddButton.prototype.handleOnRowAddClick = function (event) {
        this.matrix.addRowUI();
    };
    SurveyQuestionMatrixDynamicAddButton.prototype.renderElement = function () {
        var addRowText = this.renderLocString(this.matrix.locAddRowText);
        var addButton = (React.createElement("button", { className: this.matrix.getAddRowButtonCss(this.props.isEmptySection), type: "button", disabled: this.matrix.isInputReadOnly, onClick: this.matrix.isDesignMode ? undefined : this.handleOnRowAddClick },
            addRowText,
            React.createElement("span", { className: this.props.cssClasses.iconAdd }, this.cssClasses.iconAddId && React.createElement("svg", null,
                React.createElement("use", { xlinkHref: this.cssClasses.iconAddId })))));
        return (this.props.isEmptySection ? addButton : React.createElement("div", { className: this.props.cssClasses.footer }, addButton));
    };
    return SurveyQuestionMatrixDynamicAddButton;
}(ReactSurveyElement));
export { SurveyQuestionMatrixDynamicAddButton };
var SurveyQuestionMatrixDynamicPlaceholder = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixDynamicPlaceholder, _super);
    function SurveyQuestionMatrixDynamicPlaceholder(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionMatrixDynamicPlaceholder.prototype.renderElement = function () {
        var cssClasses = this.props.cssClasses;
        var matrix = this.props.question;
        var showAddButton = matrix.renderedTable.showAddRow;
        var text = this.renderLocString(matrix.locNoRowsText);
        var textDiv = React.createElement("div", { className: cssClasses.noRowsText }, text);
        var btn = showAddButton ? this.renderAddRowButton(cssClasses, matrix) : undefined;
        return (React.createElement("div", { className: cssClasses.noRowsSection },
            textDiv,
            btn));
    };
    SurveyQuestionMatrixDynamicPlaceholder.prototype.renderAddRowButton = function (cssClasses, question) {
        return ReactElementFactory.Instance.createElement("sv-matrixdynamic-add-btn", {
            question: question, cssClasses: cssClasses, isEmptySection: true
        });
    };
    return SurveyQuestionMatrixDynamicPlaceholder;
}(ReactSurveyElement));
export { SurveyQuestionMatrixDynamicPlaceholder };
ReactElementFactory.Instance.registerElement("sv-matrixdynamic-add-btn", function (props) { return React.createElement(SurveyQuestionMatrixDynamicAddButton, props); });
ReactElementFactory.Instance.registerElement("sv-placeholder-matrixdynamic", function (props) { return React.createElement(SurveyQuestionMatrixDynamicPlaceholder, props); });
